import Api from './Api';

const all = (payload) => {
    const path = '/client-types';
    const endpoint = payload ? `${path + '?' + Object.keys(payload).map(key => key + '=' + payload[key]).join('&')}` : path;

    return Api.getRequest({
        endpoint
    });
};

const list = (payload) => {
    const path = '/client-types-list';
    const endpoint = payload ? `${path + '?' + Object.keys(payload).map(key => key + '=' + payload[key]).join('&')}` : path;

    return Api.getRequest({
        endpoint
    });
};

const store = (payload) => {
    return Api.postRequest({
        endpoint: '/client-type/store',
        data: payload
    });
};

const update = (payload) => {
    return Api.postRequest({
        endpoint: `/client-type/${payload.id}`,
        method: 'PUT',
        data: payload
    });
};

const destroy = (payload) => {
    return Api.deleteRequest({
        endpoint: `/client-type/${payload.id}`,
    });
};

export default {
    all,
    list,
    store,
    update,
    destroy
};
